import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipVertically12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFlipVertically12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m9.997 9.449-.723-7A.5.5 0 0 0 8.777 2h-1.22l-.004-1h1.224a1.5 1.5 0 0 1 1.492 1.346l.723 7A1.5 1.5 0 0 1 9.5 11H7.596l-.005-1H9.5a.5.5 0 0 0 .497-.551M4.451 1v1H3.223a.5.5 0 0 0-.497.449l-.723 7a.5.5 0 0 0 .498.551h1.95v1h-1.95a1.5 1.5 0 0 1-1.493-1.654l.723-7A1.5 1.5 0 0 1 3.223 1zM6.51.5a.5.5 0 0 0-1 0v10.975a.5.5 0 1 0 1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFlipVertically12);
